import axios from 'axios'

import { OpenAPI } from './client/requests'
import { attachAuthorizationHeaderInterceptor, refreshIdTokenInterceptor } from './middlewares'

OpenAPI.BASE = import.meta.env.VITE_API_URL
OpenAPI.HEADERS = {
  'x-app-id': 'sakura-organization-admin',
}

OpenAPI.interceptors.request.use(async config => {
  const updatedConfig = await attachAuthorizationHeaderInterceptor(config)

  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    Authorization: updatedConfig.headers?.Authorization,
  }

  return updatedConfig
})

OpenAPI.interceptors.response.use(refreshIdTokenInterceptor)

export function setDeviceIdHeader(deviceId: string) {
  OpenAPI.HEADERS = { ...OpenAPI.HEADERS, 'x-device-id': deviceId }
}

export const getAxiosClient = () => {
  return axios.create({
    baseURL: OpenAPI.BASE,
    headers: { ...OpenAPI.HEADERS },
  })
}
